/**
 * 地図の表示範囲を検索結果に合わせて自動調整するコンポーネント
 */
import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";

interface LocationData {
  location?: {
    lat: number;
    lon: number;
  } | null;
}

interface MapBoundsUpdaterProps<T extends LocationData> {
  searchResults: T[];
}

export const MapBoundsUpdater = <T extends LocationData>({
  searchResults
}: MapBoundsUpdaterProps<T>) => {
  const map = useMap();

  useEffect(() => {
    if (searchResults.length > 0) {
      const validLocations = searchResults
        .filter((place) => place.location)
        .map((place) => [place.location!.lat, place.location!.lon] as [number, number]);

      if (validLocations.length > 0) {
        const bounds = L.latLngBounds(validLocations);
        map.fitBounds(bounds, { padding: [50, 50] });
      }
    }
  }, [searchResults, map]);

  return null;
};
